import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
// import HowIHelp from "./pages/HowIHelp";
// import Start from "./pages/Start";
// import About from "./pages/About";
// import Privacy from "./pages/Privacy";
// import Terms from "./pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/how-i-help" element={<HowIHelp />} />
          <Route path="/start" element={<Start />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;